<template>
    <div class="pending-status">
        <div>
            <h4 class="instruction-important">
                {{ $t('The image is successfully uploaded') }}
            </h4>
            <div class="instruction-important">
                {{ $t('Verification in progress') }}
            </div>
            <div class="instruction">
                {{ $t('We will check identity based on the uploaded image. This process usually last up to 24 hours. ' +
                    'After confirming identity, we will send you a confirmation. Do not hesitate to contact us via') }}
                <StaticLink
                    :shouldCapitalize="false"
                    class="action-text"
                    path="help-url"
                    label="help"
                    @click.native="$emit('helpClick')"
                />
                {{ $t('if you have any questions') }}
            </div>
        </div>
        <div class="important-box">
            <div class="important-box__left">
                <i class="icon icon--md icon-help_circle"/>
                <div>{{ $t('status') | capitalize }}</div>
            </div>
            <div class="important-box__right green">
                {{ $t('in progress') | capitalize }}
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'PendingStatus',
    };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/app/modules/userProfile/idCardVerification/components/PendingStatus.vue